import { PageRequest } from "./PageRequest";

/**
 * * Модель запроса получение списка рабочих областей
 */
export class ProjectNamespaceListRequest {
  /**
   * * Поиск по названию рабочей области
   */
  Search!: string;
  /**
   * * Идентификатор проекта
   */
  ProjectId!: number;
  /**
   * * Проверка на исполнителия
   */
  CheckInPerformer: boolean = false;
  /**
   * * Постраничка
   */
  Page!: PageRequest;
  /**
   * * Получеие только тех где пользователь является исполнителем
   */
  OnlyUserIsPerformer: boolean = false;
  /**
   * * Показать только те где текущий пользователь администратор
   */
  ShowOnlyCurrentIsAdmin: boolean = false;
  constructor(obj?: Partial<ProjectNamespaceListRequest>) {
    if (obj) {
      Object.assign(this, obj);
    }
  }
}
